import {createAction} from 'redux-actions';
import {curry} from 'ramda';
import tryToCatch from 'try-to-catch';
import {setNotificationAction as setNotification} from '@pluto/notification/Redux/NotificationActions';
import {
    getMediaOrderItems,
    deleteMediaOrder,
    restoreMediaOrder,
    getMediaOrderSortedItems,
} from '@pluto/rest';
import {MediaOrdersItemSortParams} from '../../MediaOrdersTypes';

export const MEDIA_ORDERS_ITEM_SET = 'MEDIA_ORDERS_ITEM_SET';
export const MEDIA_ORDERS_ITEM_RESET = 'MEDIA_ORDERS_ITEM_RESET';
export const MEDIA_ORDERS_ITEM_SORT = 'MEDIA_ORDERS_ITEM_SORT';

export const setMediaOrderItemSortedAction = createAction(
    MEDIA_ORDERS_ITEM_SORT,
    async (id: string, params: MediaOrdersItemSortParams) =>
        await getMediaOrderSortedItems(id, params)
);

export const setMediaOrderAction = createAction(
    MEDIA_ORDERS_ITEM_SET,
    async (params: any) => {
        const {id, offset, limit} = params;

        return await getMediaOrderItems(id, {
            offset,
            limit,
        });
    }
);

export const deleteMediaOrderItemAction = curry(async (params, dispatch) => {
    const {mediaOrderId, mediaOrderItemId} = params;
    const [error] = await tryToCatch(deleteMediaOrder, {
        mediaOrderId,
        mediaOrderItemId,
    });
    let result = {
        type: 'success',
        text: 'Media order item deleted',
    };

    if (!error) {
        return dispatch(setNotification(result));
    }

    const {data: errorData} = error.response;

    result = {
        type: 'error',
        text: errorData.message,
    };

    return dispatch(setNotification(result));
});

export const restoreMediaOrderItemAction = curry(async (params, dispatch) => {
    const {mediaOrderId, mediaOrderItemId} = params;
    const [error] = await tryToCatch(restoreMediaOrder, {
        mediaOrderId,
        mediaOrderItemId,
    });
    let result = {
        type: 'success',
        text: 'Media order item restored',
    };

    if (!error) {
        return dispatch(setNotification(result));
    }

    const {data: errorData} = error.response;

    result = {
        type: 'error',
        text: errorData.message,
    };

    return dispatch(setNotification(result));
});

export const resetMediaOrderAction = createAction(MEDIA_ORDERS_ITEM_RESET);
